import { initProductBuyTile } from '../../../snippets/product-buy-tile/product-buy-tile';
import { initProductBuyTileDimmerPack } from '../../../snippets/product-buy-tile-dimmer-pack/product-buy-tile-dimmer-pack';

export const initSwitchesAndPlugsSectionTiles = () => {
  const switchProductEls = document.querySelectorAll(
    '[data-list-collections-switches-product]'
  );

  switchProductEls.forEach((productEl) => {
    const productId = productEl.getAttribute(
      'data-list-collections-switches-product'
    );

    if (productId) {
      initProductBuyTile(productId);
    }
  });

  const packSwitchProductEls = document.querySelectorAll(
    '[data-list-collections-switches-pack-product]'
  );

  packSwitchProductEls.forEach((productEl) => {
    const productId = productEl.getAttribute(
      'data-list-collections-switches-pack-product'
    );

    if (productId) {
      initProductBuyTileDimmerPack(productId);
    }
  });
};
